import { useAuth } from '@/contexts/AuthContext';
import { usePermissions } from './usePermissions';

/**
 * Hook for OptiAssets feature access and permissions
 * OptiAssets is gated by the 'OPTIASSETS' addon in shops.addons
 */
export function useOptiAssets() {
  const { activeShop } = useAuth();
  const permissions = usePermissions();
  
  // Check if OPTIASSETS addon is enabled for the shop
  const isEnabled = activeShop?.addons?.includes('OPTIASSETS') ?? false;
  
  return {
    // Feature availability
    isEnabled,
    
    // Permissions (all require isEnabled implicitly via RLS)
    canView: isEnabled && permissions.canViewAssets,
    canEdit: isEnabled && permissions.canEditAssets,
    canDelete: isEnabled && permissions.canDeleteAssets,
    canLogUsage: isEnabled && permissions.canLogAssetUsage,
    canViewCosts: isEnabled && permissions.canViewAssetCosts,
    
    // Shop data
    laborRate: activeShop?.labor_rate ?? 150,
  };
}
